const galleryId = 24;

const items = [];

let id = galleryId * 1000;
function addItemToGroup(item, tag) {
    id++;
    items.push({
        "id": id,
        "title": { "en": "" },
        "src": item,
        "tags": [tag],
        "groups": [galleryId],
        "ordering": id,
    });
}
let group = [];

group = ["sh_1741122341.jpg","sh_1741122338.jpg","sh_1741122335.jpg","sh_1829640734.jpg","sh_1741122332.jpg","sh_1829640728.jpg"];
group.forEach((i) => addItemToGroup(i, '1. Gum graft procedure'));

group = ["sh_1710200311.jpg","sh_1710200314.jpg","sh_1542434423.jpg"];
group.forEach((i) => addItemToGroup(i, '2. Gum surgery'));

group = ["sh_1822690388.jpg","sh_1319862581.jpg","sh_1828180235.jpg","sh_1735910297.jpg"];
group.forEach((i) => addItemToGroup(i, 'Before-after'));

group = ["sh_176391953.jpg","sh_1734010490.jpg"];
group.forEach((i) => addItemToGroup(i, 'deleted'));

group = ["sh_1829640617.jpg","sh_1829640608.jpg","sh_1829640611.jpg"];
group.forEach((i) => addItemToGroup(i, 'x_4. Gum surgery 2 - ínyt felhúzni, berakni a gum suregry-be'));

export default items;
